/* eslint-disable no-console */
/* eslint-disable max-len */
import React from 'react';
import { checkStorage } from '../../actions/media_actions';
import { useSelector } from 'react-redux';
import { catchErr, roleCondition } from '../../../libs/HelperContent';
import { toast } from 'react-toastify';

const useUpdateStorage = () =>
{
	const userData = useSelector((state: any) => state?.mysession?.session);

	const setStorageData = async ({ action, size, ownerCompanyId }) =>
	{
		const query:any = {
			comid : ownerCompanyId,
			action,
			size
		};

		try
		{
			const res:any = await checkStorage(query);

			return res;
		}
		catch (err:any)
		{
			console.log('err**', err);
			const checkRole = roleCondition(userData?.empRole);

			if (err?.response?.data?.statusCode === 507)
			{
				toast.error(`Storage limit exceeded ${checkRole ? '' : 'Please contact your Admin'}`, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});

				return err?.response?.data;
			}
			else
			{
				catchErr(err);

				throw err;
			}
		}
	};

	return setStorageData;
};

export default useUpdateStorage;